import { render, staticRenderFns } from "./platformMac.vue?vue&type=template&id=20acf080&scoped=true&"
import script from "./platformMac.vue?vue&type=script&lang=js&"
export * from "./platformMac.vue?vue&type=script&lang=js&"
import style0 from "./platformMac.vue?vue&type=style&index=0&lang=css&"
import style1 from "./platformMac.vue?vue&type=style&index=1&id=20acf080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20acf080",
  null
  
)

export default component.exports